import { QuestionEnum } from '@helpers/enums';
import { IFilterDynamic } from './iFilterDynamic';

interface IParameters {
  negotiations_types_id: (number | null)[];
  negotiations_types_statuses_id: (number | null)[];
  batches_id: (number | null)[];
  searchText: string;
  entity_list_type?: string;
  entities_type_id: number | null;
  filtersDynamics: IFilterDynamic[];
}
export interface IPortfolioFilters {
  showPhotograph: QuestionEnum;
  parameters: IParameters;
}

class PortfolioFiltersClass implements IPortfolioFilters {
  showPhotograph: QuestionEnum;
  parameters: IParameters;

  constructor(showPhotograph: QuestionEnum, parameters: any) {
    this.showPhotograph = showPhotograph;
    this.parameters = parameters;
  }
}

export default PortfolioFiltersClass;
